import axios from "axios";

const API_BASE = "/api/v1/salary";

export const SalaryService = {
  // Master data
  getMasterData: () => axios.get(`${API_BASE}/master`),
  getBanks: () => axios.get(`${API_BASE}/banks`),
  getIncomes: () => axios.get(`${API_BASE}/incomes`),
  getOutcomes: () => axios.get(`${API_BASE}/outcomes`),
  getTypeGov: () => axios.get(`${API_BASE}/typegov`).catch(() => axios.get(`/api/v1/typegov`)),

  // Monthly Summary & Detail
  getMonthlySummary: (calYear, calMonth, typeGov, search) =>
    axios.get(`${API_BASE}/summary`, {
      params: { calYear, calMonth, typeGov, search }
    }),
  getPersonDetail: (userName, calYear, calMonth) =>
    axios.get(`${API_BASE}/person/${userName}`, {
      params: { calYear, calMonth }
    }),
  savePersonDetail: data => axios.post(`${API_BASE}/person-detail`, data),
  batchConfirmMonth: data => axios.post(`${API_BASE}/batch-confirm`, data),
  rolloverMonth: data => axios.post(`${API_BASE}/rollover`, data),

  // Batch Category items (e.g. all employees for 1 category)
  getCategoryItems: (calYear, calMonth, typeInOut, itemId, typeGov) =>
    axios.get(`${API_BASE}/category-items`, {
      params: { calYear, calMonth, typeInOut, itemId, typeGov }
    }),
  saveCategoryItems: data => axios.post(`${API_BASE}/category-items`, data),

  // Person / Bank Account Configuration
  getSalaryPersons: (typeGov, search) =>
    axios.get(`${API_BASE}/persons`, { params: { typeGov, search } }),
  getSalaryPersonConfig: userName =>
    axios.get(`${API_BASE}/person-config/${userName}`),
  getUnmappedEmployees: () => axios.get(`${API_BASE}/unmapped-employees`),
  saveSalaryPersonConfig: data => axios.post(`${API_BASE}/person-config`, data),
  toggleSalaryPersonActive: (userName, isActive) =>
    axios.post(`${API_BASE}/toggle-active`, { userName, isActive }),

  // Permission Check
  checkPermission: userName =>
    axios.get(`${API_BASE}/check-permission`, { params: { userName } }),

  // Salary Slip Report
  getSalarySlip: (userName, calYear, calMonth) =>
    axios.get(`${API_BASE}/slip/${userName}`, {
      params: { calYear, calMonth }
    }),
  getMySlip: (calYear, calMonth, userName) =>
    axios.get(`${API_BASE}/my-slip`, {
      params: { calYear, calMonth, userName }
    }),
  getMySlipMonths: (calYear, userName) =>
    axios.get(`${API_BASE}/my-slip-months`, {
      params: { calYear, userName }
    })
};
